/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './AiAgentInstancesChirpServiceV2';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#getAgentInstance
 */
export const GET_AGENT_INSTANCE_QUERY_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_getAgentInstance';
export const GET_AGENT_INSTANCE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_AGENT_INSTANCE_QUERY_FIELD_NAME,
  args: ['id', 'feedbackCorrelationId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getAgentInstanceRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#getAgentInstancesByIDs
 */
export const GET_AGENT_INSTANCES_BY_IDS_QUERY_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_getAgentInstancesByIDs';
export const GET_AGENT_INSTANCES_BY_IDS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_AGENT_INSTANCES_BY_IDS_QUERY_FIELD_NAME,
  args: ['ids'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getAgentInstancesByIDsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#getAgentInstancesByStatus
 */
export const GET_AGENT_INSTANCES_BY_STATUS_QUERY_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_getAgentInstancesByStatus';
export const GET_AGENT_INSTANCES_BY_STATUS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_AGENT_INSTANCES_BY_STATUS_QUERY_FIELD_NAME,
  args: ['statuses', 'visibility', 'pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getAgentInstancesByStatusRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#getActiveAgentInstances
 */
export const GET_ACTIVE_AGENT_INSTANCES_QUERY_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_getActiveAgentInstances';
export const GET_ACTIVE_AGENT_INSTANCES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ACTIVE_AGENT_INSTANCES_QUERY_FIELD_NAME,
  args: ['visibility', 'pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getActiveAgentInstancesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#listAgentInstances
 */
export const LIST_AGENT_INSTANCES_QUERY_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_listAgentInstances';
export const LIST_AGENT_INSTANCES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LIST_AGENT_INSTANCES_QUERY_FIELD_NAME,
  args: ['pageLength', 'visibilities', 'visibility', 'requiredAccessType', 'authorName', 'updatedBy', 'searchTerm', 'sortField', 'sortDirection', 'statuses', 'permissionTypeFilters', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.listAgentInstancesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#createAgentInstance
 */
export const CREATE_AGENT_INSTANCE_MUTATION_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_createAgentInstance';
export const CREATE_AGENT_INSTANCE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_AGENT_INSTANCE_MUTATION_FIELD_NAME,
  args: ['instance', 'triggerFlowIds', 'permissions', 'feedbackCorrelationId'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.createAgentInstanceRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#updateAgentInstance
 */
export const UPDATE_AGENT_INSTANCE_MUTATION_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_updateAgentInstance';
export const UPDATE_AGENT_INSTANCE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_AGENT_INSTANCE_MUTATION_FIELD_NAME,
  args: ['id', 'instance', 'triggerFlowIds', 'permissions', 'feedbackCorrelationId'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.updateAgentInstanceRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#factoryReset
 */
export const FACTORY_RESET_MUTATION_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_factoryReset';
export const FACTORY_RESET_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: FACTORY_RESET_MUTATION_FIELD_NAME,
  args: ['id', 'feedbackCorrelationId'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.factoryResetRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#softDeleteAgentInstance
 */
export const SOFT_DELETE_AGENT_INSTANCE_MUTATION_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_softDeleteAgentInstance';
export const SOFT_DELETE_AGENT_INSTANCE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SOFT_DELETE_AGENT_INSTANCE_MUTATION_FIELD_NAME,
  args: ['id', 'feedbackCorrelationId'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.softDeleteAgentInstanceRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#createInstanceFromTemplate
 */
export const CREATE_INSTANCE_FROM_TEMPLATE_MUTATION_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_createInstanceFromTemplate';
export const CREATE_INSTANCE_FROM_TEMPLATE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_INSTANCE_FROM_TEMPLATE_MUTATION_FIELD_NAME,
  args: ['templateId', 'objective', 'components', 'builtInTools', 'detach'],
  fetcher(request, ctx) {
    var _ctx$customClient10;
    return ((_ctx$customClient10 = ctx.customClient) !== null && _ctx$customClient10 !== void 0 ? _ctx$customClient10 : chirpClient).call(References.createInstanceFromTemplateRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#createInstanceFromTemplateByGlobalId
 */
export const CREATE_INSTANCE_FROM_TEMPLATE_BY_GLOBAL_ID_MUTATION_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_createInstanceFromTemplateByGlobalId';
export const CREATE_INSTANCE_FROM_TEMPLATE_BY_GLOBAL_ID_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_INSTANCE_FROM_TEMPLATE_BY_GLOBAL_ID_MUTATION_FIELD_NAME,
  args: ['globalId', 'globalIdString', 'objective', 'components', 'builtInTools', 'detach'],
  fetcher(request, ctx) {
    var _ctx$customClient11;
    return ((_ctx$customClient11 = ctx.customClient) !== null && _ctx$customClient11 !== void 0 ? _ctx$customClient11 : chirpClient).call(References.createInstanceFromTemplateByGlobalIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#cloneAgentInstance
 */
export const CLONE_AGENT_INSTANCE_MUTATION_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_cloneAgentInstance';
export const CLONE_AGENT_INSTANCE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CLONE_AGENT_INSTANCE_MUTATION_FIELD_NAME,
  args: ['instanceId', 'cloneName', 'detach'],
  fetcher(request, ctx) {
    var _ctx$customClient12;
    return ((_ctx$customClient12 = ctx.customClient) !== null && _ctx$customClient12 !== void 0 ? _ctx$customClient12 : chirpClient).call(References.cloneAgentInstanceRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#getInstancesByTemplateIds
 */
export const GET_INSTANCES_BY_TEMPLATE_IDS_QUERY_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_getInstancesByTemplateIds';
export const GET_INSTANCES_BY_TEMPLATE_IDS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_INSTANCES_BY_TEMPLATE_IDS_QUERY_FIELD_NAME,
  args: ['templateIds'],
  fetcher(request, ctx) {
    var _ctx$customClient13;
    return ((_ctx$customClient13 = ctx.customClient) !== null && _ctx$customClient13 !== void 0 ? _ctx$customClient13 : chirpClient).call(References.getInstancesByTemplateIdsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#getInstancesByGlobalId
 */
export const GET_INSTANCES_BY_GLOBAL_ID_QUERY_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_getInstancesByGlobalId';
export const GET_INSTANCES_BY_GLOBAL_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_INSTANCES_BY_GLOBAL_ID_QUERY_FIELD_NAME,
  args: ['globalId', 'globalIdString'],
  fetcher(request, ctx) {
    var _ctx$customClient14;
    return ((_ctx$customClient14 = ctx.customClient) !== null && _ctx$customClient14 !== void 0 ? _ctx$customClient14 : chirpClient).call(References.getInstancesByGlobalIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#uploadFilesToAgentInstance
 */
export const UPLOAD_FILES_TO_AGENT_INSTANCE_MUTATION_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_uploadFilesToAgentInstance';
export const UPLOAD_FILES_TO_AGENT_INSTANCE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPLOAD_FILES_TO_AGENT_INSTANCE_MUTATION_FIELD_NAME,
  args: ['agentInstanceId', 'fileIds'],
  fetcher(request, ctx) {
    var _ctx$customClient15;
    return ((_ctx$customClient15 = ctx.customClient) !== null && _ctx$customClient15 !== void 0 ? _ctx$customClient15 : chirpClient).call(References.uploadFilesToAgentInstanceRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#findComponentUsage
 */
export const FIND_COMPONENT_USAGE_QUERY_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_findComponentUsage';
export const FIND_COMPONENT_USAGE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: FIND_COMPONENT_USAGE_QUERY_FIELD_NAME,
  args: ['actionTypeId', 'type', 'offset', 'pageLength', 'authenticatorId', 'fqn', 'method', 'tool', 'boxId', '__typename'],
  fetcher(request, ctx) {
    var _ctx$customClient16;
    return ((_ctx$customClient16 = ctx.customClient) !== null && _ctx$customClient16 !== void 0 ? _ctx$customClient16 : chirpClient).call(References.findComponentUsageRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#updateAgentInstanceOwner
 */
export const UPDATE_AGENT_INSTANCE_OWNER_MUTATION_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_updateAgentInstanceOwner';
export const UPDATE_AGENT_INSTANCE_OWNER_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_AGENT_INSTANCE_OWNER_MUTATION_FIELD_NAME,
  args: ['agentInstanceId', 'newOwnerId'],
  fetcher(request, ctx) {
    var _ctx$customClient17;
    return ((_ctx$customClient17 = ctx.customClient) !== null && _ctx$customClient17 !== void 0 ? _ctx$customClient17 : chirpClient).call(References.updateAgentInstanceOwnerRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#updateAgentInstanceFromSnapshot
 */
export const UPDATE_AGENT_INSTANCE_FROM_SNAPSHOT_MUTATION_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_updateAgentInstanceFromSnapshot';
export const UPDATE_AGENT_INSTANCE_FROM_SNAPSHOT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_AGENT_INSTANCE_FROM_SNAPSHOT_MUTATION_FIELD_NAME,
  args: ['instanceId', 'snapshotId', 'additionalSetupInputs', 'authorName', 'triggerFlowIds', 'permissions'],
  fetcher(request, ctx) {
    var _ctx$customClient18;
    return ((_ctx$customClient18 = ctx.customClient) !== null && _ctx$customClient18 !== void 0 ? _ctx$customClient18 : chirpClient).call(References.updateAgentInstanceFromSnapshotRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#cloneInstanceFromSnapshot
 */
export const CLONE_INSTANCE_FROM_SNAPSHOT_MUTATION_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_cloneInstanceFromSnapshot';
export const CLONE_INSTANCE_FROM_SNAPSHOT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CLONE_INSTANCE_FROM_SNAPSHOT_MUTATION_FIELD_NAME,
  args: ['instanceId', 'snapshotId', 'cloneName', 'detach'],
  fetcher(request, ctx) {
    var _ctx$customClient19;
    return ((_ctx$customClient19 = ctx.customClient) !== null && _ctx$customClient19 !== void 0 ? _ctx$customClient19 : chirpClient).call(References.cloneInstanceFromSnapshotRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#submitPromptFeedback
 */
export const SUBMIT_PROMPT_FEEDBACK_MUTATION_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_submitPromptFeedback';
export const SUBMIT_PROMPT_FEEDBACK_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SUBMIT_PROMPT_FEEDBACK_MUTATION_FIELD_NAME,
  args: ['agentInstanceId', 'templateId', 'generatedPrompt', 'positive', 'explicit', 'feedback', 'correlationId'],
  fetcher(request, ctx) {
    var _ctx$customClient20;
    return ((_ctx$customClient20 = ctx.customClient) !== null && _ctx$customClient20 !== void 0 ? _ctx$customClient20 : chirpClient).call(References.submitPromptFeedbackRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#validateAgentInstanceReadiness
 */
export const VALIDATE_AGENT_INSTANCE_READINESS_MUTATION_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_validateAgentInstanceReadiness';
export const VALIDATE_AGENT_INSTANCE_READINESS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: VALIDATE_AGENT_INSTANCE_READINESS_MUTATION_FIELD_NAME,
  args: ['instanceId', 'instancePayload', 'runtimeInputs'],
  fetcher(request, ctx) {
    var _ctx$customClient21;
    return ((_ctx$customClient21 = ctx.customClient) !== null && _ctx$customClient21 !== void 0 ? _ctx$customClient21 : chirpClient).call(References.validateAgentInstanceReadinessRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});